import { render, staticRenderFns } from "./OffersTable.vue?vue&type=template&id=e385e790&scoped=true&"
import script from "./OffersTable.vue?vue&type=script&lang=js&"
export * from "./OffersTable.vue?vue&type=script&lang=js&"
import style0 from "./OffersTable.vue?vue&type=style&index=0&id=e385e790&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e385e790",
  null
  
)

export default component.exports